import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import companyReducer from "../../slices/companySlice";
import addressReducer from "../../slices/addressSlice";
import categoryReducer from "../../slices/categorySlice";
import displayLanguageReducer from "../../slices/displayLanguageSlice";
import notificationReducer from "../../slices/notificationSlice";

export const store = configureStore({
  reducer: {
    company: companyReducer,
    address: addressReducer,
    category: categoryReducer,
    displayLanguage: displayLanguageReducer,
    notification: notificationReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
